import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n'
  import LockIcon from '@/assets/LockIcon.vue'

  // Store
  import { useStore } from 'vuex'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Logout',
  setup(__props) {

  // Translations
  const { t } = useI18n()

  // Icons
  const store = useStore()

  // Computed
  const logout = (): void => {
    store.dispatch('auth/logout')
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: "body text-grey-900 cursor-pointer d-flex py-md-2 px-md-3",
    onClick: logout
  }, [
    _createVNode(LockIcon, { class: "text-grey-900 mb-1 mb-lg-0 me-lg-3" }),
    _createTextVNode(" " + _toDisplayString(_unref(t)('navbar.logout')), 1)
  ]))
}
}

})